// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__CzpuQ","ranges":"BmiRanges_ranges__2IPbB"};